import LiveChatAdmin from '@/components/LiveChatAdmin';

const ChatPage = () => {
  return <LiveChatAdmin />;
};

export default ChatPage;
